"use client";

export {
  ModalCloseButton,
  ModalHeader,
  ModalBody,
  ModalBodyContent,
  ModalFooter,
  MODAL_HEADER_CLASSNAME,
} from "@aera/ui";
export type {
  ModalCloseButtonProps,
  ModalHeaderProps,
  ModalBodyProps,
  ModalBodyContentProps,
  ModalFooterProps,
} from "@aera/ui";
